<div class="tool-content-container">
  <div class="tool-description">
    Select a college, <instruction-step-link link="program" text="program" />,
    UWF year, and <instruction-step-link link="semesters" text="semester" />,
    then click submit to generate bottleneck course results.
    <!-- <b class="instructions-title"
      >To generate results for program bottleneck courses:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Select a College<br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="program" text="Program" />
    <br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select a UWF Year
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="All: Gives a combined pass rate for all years; UWFYear1 - UWFYear4: Gives a pass rate for the selected year."
      matTooltipPosition="right"
    ></i
    ><br />
    Step 4 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="semesters" text="Semester" />
    <br />
    Step 5 <i class="fa-solid fa-arrow-right"></i> Click on the submit button<br /><br /> -->
  </div>

  <div *ngIf="programBottleneckData?.courses?.length; else noCourses">
    <div
      *ngIf="!mobileView; else showMobileView"
      class="program-bottleneck-table-container mat-elevation-z8"
    >
      <div class="table-filters-title" [style.paddingTop]="'5px'">
        <p>
          <span [style.fontWeight]="'bold'">Selected:</span>
          {{ getSelectedFilterStr() }}
        </p>
      </div>
      <table
        mat-table
        [dataSource]="programBottleneckData.courses"
        multiTemplateDataRows
        class="program-bottleneck-table"
      >
        <!-- College Column -->
        <ng-container matColumnDef="college">
          <th mat-header-cell *matHeaderCellDef>College</th>
          <td mat-cell *matCellDef="let course">{{ course.college }}</td>
        </ng-container>

        <!-- Course Column -->
        <ng-container matColumnDef="course_code">
          <th mat-header-cell *matHeaderCellDef>Course Code</th>
          <td mat-cell *matCellDef="let course">{{ course.course_code }}</td>
        </ng-container>

        <!-- Course Name Column -->
        <ng-container matColumnDef="course_name">
          <th mat-header-cell *matHeaderCellDef>Course Name</th>
          <td mat-cell *matCellDef="let course">{{ course.course_name }}</td>
        </ng-container>

        <!-- Program Column -->
        <ng-container matColumnDef="program">
          <th mat-header-cell *matHeaderCellDef>Program</th>
          <td mat-cell *matCellDef="let course">{{ course.program }}</td>
        </ng-container>

        <!-- Passing Rate Column -->
        <ng-container matColumnDef="pass_rate">
          <th mat-header-cell *matHeaderCellDef>Pass Rate</th>
          <td mat-cell *matCellDef="let course">
            {{ course.pass_rate | number: '1.2-2' }}
          </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length"
          >
            <div
              class="example-element-detail"
              [@detailExpand]="
                element == expandedElement ? 'expanded' : 'collapsed'
              "
            >
              <div class="example-element-description">{{ element.desc }}</div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="example-element-row"
          [class.example-expanded-row]="expandedElement === element"
          (click)="
            expandedElement = expandedElement === element ? null : element
          "
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"
        ></tr>
      </table>
    </div>

    <!-- Mobile View -->
    <ng-template #showMobileView>
      <mat-table
        [dataSource]="programBottleneckData.courses"
        class="mat-elevation-z8 table-container"
      >
        <ng-container
          *ngFor="let col of displayedColumns; index as i"
          [matColumnDef]="col"
        >
          <mat-header-cell *matHeaderCellDef>{{ col }}</mat-header-cell>
          <mat-cell *matCellDef="let element"
            ><span>{{ col }}:</span>{{ element[col] }}</mat-cell
          >
        </ng-container>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </ng-template>
  </div>

  <ng-template #noCourses>
    <b class="warning-note">
      No courses found for the selected filters. Please adjust your selections.
    </b>
  </ng-template>

  <back-button></back-button>
</div>
